import clsx from "clsx";
import { STATUS_META } from "../lib/format";
import type { EmployeeStatus } from "../lib/types";

export default function StatusPill({ status }: { status: EmployeeStatus }) {
  const m = STATUS_META[status];
  return (
    <span
      className={clsx(
        "inline-flex items-center gap-1.5 px-2 py-0.5 rounded-full text-xs ring-1 bg-slate-900/60",
        m.ring,
        m.color,
      )}
    >
      <span className={clsx("inline-block w-1.5 h-1.5 rounded-full", m.dot)} />
      {m.label}
    </span>
  );
}
